// src/ConsumerApp/api/payment/payment.hooks.js
import { useMutation } from '@tanstack/react-query';
import { PaymentService } from './payment.service';

export const useInitiatePayment = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await PaymentService.initiatePayment(payload);
      return response.data || response;
    },
  });
};

export const useVerifyPaymentStatus = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await PaymentService.verifyPaymentStatus(payload);
      return response.data || response;
    },
  });
};